import auth from "../middleware/auth";
import userExists from "../middleware/userExists";
import isStaff from "@/router/middleware/isStaff.js";
import redirectParents from "@/router/middleware/journal/redirectParents.js";
import entryExists from "../middleware/journal/entryExists";
import commentExists from "../middleware/journal/commentExists";
import journalClassExists from "../middleware/journal/journalClassExists";
import pupilUserFilterEntries from "../middleware/journal/pupilUserFilterEntries";

export default [
    {
        path: "/journal",
        props: true,
        component: () => {
            return import(
                 "@/projects/journal/App.vue"
            );
        },
        meta: {
            middleware: [auth(), redirectParents()],
            title: "journal",
        },
        children: [
            {
                path: "",
                name: "journal.home",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/List.vue"
                        );
                    },
                },
                meta: {
                    title: "journal.home"
                }
            },
            {
                path: "users/:userId",
                name: "journal.user",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/UserEntries.vue"
                        );
                    },
                    sidebar1: () => {
                        return import(
                             "@/projects/journal/sidebars/User.vue"
                        );
                    },
                    sidebar2: () => {
                        return import(
                             "@/projects/journal/sidebars/UserFilter.vue"
                        );
                    }
                },
                meta: {
                    middleware: [userExists],
                    title: "journal.list.title"
                }
            },
            {
                path: "entries/:entryId",
                name: "journal.entry",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/SingleEntry.vue"
                        );
                    },
                },
                meta: {
                    middleware: [entryExists],
                    title: "journal.entry.title"
                }
            },
            {
                path: "comments/:commentId",
                name: "journal.comment",
                props: true,
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/SingleComment.vue"
                        );
                    },
                },
                meta: {
                    middleware: [commentExists],
                    title: "journal.comment.title"
                }
            },
        ]
    },
    {
        path: "/journal/:classId",
        props: true,
        component: () => {
            return import(
                 "@/projects/journal/App.vue"
            );
        },
        meta: {
            middleware: [auth(), redirectParents(),journalClassExists],
            title: "journal",
        },
        children:[
            {
                path: "entry/new",
                props: {subview:true},
                name: "journal.class.newentry",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/CreateEntry.vue"
                        );
                    },
                },
                meta: {
                    title: "journal.class.newentry"
                }
            },
            {
                path: "entry/:entryId/edit",
                name: "journal.class.editentry",
                props: {subview:true},
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/CreateEntry.vue"
                        );
                    },
                },
                meta: {
                    title: "journal.class.editentry",
                    middleware: [entryExists],
                }
            },
            {
                path: "unapproved",
                name: "journal.class.unapproved",
                props: {subview:true, sidebar1:true, sidebar2:true},
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/PendingClassEntries.vue"
                        );
                    },
                    sidebar1: () => {
                        return import(
                             "@/projects/journal/sidebars/ClassGroup.vue"
                        );
                    },
                    sidebar2: () => {
                        return import(
                             "@/projects/journal/sidebars/Filter.vue"
                        );
                    }
                },
                meta: {
                    title: "journal.class.unapproved",
                    middleware: [isStaff],
                }
            },
            {
                path: "",
                name: "journal.class",
                props: {subview:true, sidebar1:true, sidebar2:true},
                components: {
                    subview: () => {
                        return import(
                             "@/projects/journal/views/Entries.vue"
                        );
                    },
                    sidebar1: () => {
                        return import(
                             "@/projects/journal/sidebars/ClassGroup.vue"
                        );
                    },
                    sidebar2: () => {
                        return import(
                             "@/projects/journal/sidebars/Filter.vue"
                        );
                    }
                },
                meta: {
                    title: "journal.class.title",
                    middleware: [pupilUserFilterEntries]
                }
            },

        ]
    },
];
